import React from 'react'
import { BiCalendar, BiCalendarCheck, BiCalendarHeart, BiCalendarX } from 'react-icons/bi'
import { CalClock } from '../../../../assets'
import { AgendamentoContext } from '../../../../contexts/AgendamentoContext'

export default function BttIcone({ text, idx }) {
  const { sttCtxAgend, loadAgend, actionsAgend } = React.useContext(AgendamentoContext)

  function VerificaStatusFiltro() {
    if (sttCtxAgend.typePed === 'Solicitados' && idx === 0) {
      return true
    } else if (sttCtxAgend.typePed === 'Agendados' && idx === 1) {
      return true
    } else if (sttCtxAgend.typePed === 'Realizados' && idx === 2) {
      return true
    } else if (sttCtxAgend.typePed === 'Cancelados' && idx === 3) {
      return true
    } else if (sttCtxAgend.typePed === 'Todos' && idx === 4) {
      return true
    } else {
      return false
    }
  }

  switch (idx) {
    case 0:
      return (
        <button
          className={
            VerificaStatusFiltro() ? 'btt-list-pedidos-sel btt-sel-solicitado' : 'btt-list-pedidos'
          }
          style={{ borderRadius: '7px 0px 0px 7px' }}
          onClick={() => {
            if (!loadAgend.list && !loadAgend.pagina)
              actionsAgend.handleSttCtxAgend('typePed', 'Solicitados')
          }}
        >
          <img
            src={CalClock}
            className='color-pedido-solicitado'
            style={{ width: '30px', height: '30px' }}
            alt='Ícone de pedido solicitado'
          />
          <h2 className='text-btt-list-pedidos color-pedido-solicitado'>{text}</h2>
        </button>
      )
    case 1:
      return (
        <button
          className={
            VerificaStatusFiltro() ? 'btt-list-pedidos-sel btt-sel-agendado' : 'btt-list-pedidos'
          }
          onClick={() => {
            if (!loadAgend.list && !loadAgend.pagina)
              actionsAgend.handleSttCtxAgend('typePed', 'Agendados')
          }}
        >
          <BiCalendarHeart className='color-pedido-agendado' size={30} />
          <h2 className='text-btt-list-pedidos color-pedido-agendado'>{text}</h2>
        </button>
      )
    case 2:
      return (
        <button
          className={
            VerificaStatusFiltro() ? 'btt-list-pedidos-sel btt-sel-realizado' : 'btt-list-pedidos'
          }
          onClick={() => {
            if (!loadAgend.list && !loadAgend.pagina)
              actionsAgend.handleSttCtxAgend('typePed', 'Realizados')
          }}
        >
          <BiCalendarCheck className='color-pedido-realizado' size={30} />
          <h2 className='text-btt-list-pedidos color-pedido-realizado'>{text}</h2>
        </button>
      )
    case 3:
      return (
        <button
          className={
            VerificaStatusFiltro() ? 'btt-list-pedidos-sel btt-sel-cancelado' : 'btt-list-pedidos'
          }
          onClick={() => {
            if (!loadAgend.list && !loadAgend.pagina)
              actionsAgend.handleSttCtxAgend('typePed', 'Cancelados')
          }}
        >
          <BiCalendarX className='color-pedido-cancelado' size={30} />
          <h2 className='text-btt-list-pedidos color-pedido-cancelado'>{text}</h2>
        </button>
      )
    case 4:
      return (
        <button
          className={
            VerificaStatusFiltro() ? 'btt-list-pedidos-sel btt-sel-todos' : 'btt-list-pedidos'
          }
          style={{ borderRadius: '0px 7px 7px 0px' }}
          onClick={() => {
            if (!loadAgend.list && !loadAgend.pagina)
              actionsAgend.handleSttCtxAgend('typePed', 'Todos')
          }}
        >
          <BiCalendar size={30} />
          <h2 className='text-btt-list-pedidos'>{text}</h2>
        </button>
      )
    default:
      return null
  }
}
